import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import { all_information, loadingShow } from '../../App';
import { getTrainingSettings } from '../../services/Position/PositionServices';
import Message from '../../utils/Message/Message';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { BsCheck2 } from 'react-icons/bs';
import { BiX } from 'react-icons/bi';
import moment from 'moment';
import { getEventResources } from '../../services/EventResources/EventResources';
import {
  deleteAssignment,
  addAssignment,
  editAssignment,
  getMasterAssignment,
} from '../../services/assignments/assignmentService';
import { getCompany } from '../../services/Company/CompanyServices';
import { getDepartment } from '../../services/Department/DepartmentServices';
interface IState {
  visibleAddDialog: boolean;
  visibleEditDialog: boolean;
  visibleDeleteDialog: boolean;
  ResourceMasterData: any;
  EventResourcesData: any;
  positionsData: any;
  departmentData: Array<any>;
  siteData: Array<any>;
}
interface IProps {
  GridHeight?: any;
  gridRef?: (component: GridComponent) => void;
  onGridSelected?: (args: any) => void;
  onGridDeSelected?: (args: any) => void;
  allowMultiSelectection?: boolean;
  height?: string;
}
export class ResourceMaster extends Component<IProps, IState> {
  private ResourceMasterGrid: GridComponent;
  private assignment_id: number = -1;
  private isAdd: boolean = true;
  private DDRMManager: DropDownListComponent;
  private DDRMPosition: DropDownListComponent;
  private DDRMDepartment: DropDownListComponent;
  private DDRMSite: DropDownListComponent;
  private switchForIsTradePerson: any;
  public validationRule: Object = { required: true };
  constructor(props: IProps) {
    super(props);
    this.ResourceMasterGrid = new GridComponent(props);
    this.state = {
      visibleAddDialog: false,
      visibleEditDialog: false,
      visibleDeleteDialog: false,
      ResourceMasterData: [],
      EventResourcesData: [],
      positionsData: [],
      departmentData: [],
      siteData: [],
    };
    this.DDRMManager = new DropDownListComponent({});
    this.DDRMPosition = new DropDownListComponent({});
    this.DDRMDepartment = new DropDownListComponent({});
    this.DDRMSite = new DropDownListComponent({});
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showDeleteConfirmDialog: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  getEventResources() {
    getEventResources().then((res) => {
      let model = res.data.map((items: any) => {
        return {
          ...items,
          fullName: items.firstName + ' ' + items.lastName,
        };
      });
      this.setState({ EventResourcesData: model });
    });
  }

  getPositions() {
    getTrainingSettings('position').then((res) => {
      this.setState({ positionsData: res.data });
      loadingShow(false);
    });
  }

  getCompanySites() {
    getCompany()
      .then((el) => {
        const data = el.data.filter((el: any) => {
          return el.isParent === false;
        });
        this.setState({ siteData: data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getDepartment() {
    getDepartment()
      .then((el) => {
        this.setState({ departmentData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }

  deleteResourceMaster() {
    const obj = {
      assignment_id: this.assignment_id,
    };

    deleteAssignment(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getResourceMaster();
        this.setState({ visibleDeleteDialog: false });
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }

  managerTemplate(args: any) {
    return (
      <DropDownListComponent
        ref={(el: DropDownListComponent) => {
          this.DDRMManager = el;
        }}
        placeholder='Project Manager'
        value={args.manager_id}
        text={args.manager}
        style={{ height: 25 }}
        dataSource={this.state.EventResourcesData}
        fields={{
          text: 'fullName',
          value: 'id',
        }}
        onChange={(e: any) => {}}
      />
    );
  }
  positionTemplate(args: any) {
    return (
      <DropDownListComponent
        ref={(el: DropDownListComponent) => {
          this.DDRMPosition = el;
        }}
        placeholder='Position'
        value={args.position_id}
        text={args.position_name}
        style={{ height: 25 }}
        dataSource={this.state.positionsData}
        fields={{
          text: 'name',
          value: 'ID',
        }}
      />
    );
  }

  departmentTemplate(args: any) {
    return (
      <DropDownListComponent
        ref={(el: DropDownListComponent) => {
          this.DDRMDepartment = el;
        }}
        placeholder='Department'
        text={args.department_code}
        value={args.department_id}
        style={{ height: 25 }}
        dataSource={this.state.departmentData}
        fields={{
          text: 'department_code',
          value: 'department_id',
        }}
      />
    );
  }
  siteTemplate(args: any) {
    return (
      <DropDownListComponent
        ref={(el: DropDownListComponent) => {
          this.DDRMSite = el;
        }}
        placeholder='Site'
        text={args.site_assigned}
        value={args.site_id}
        style={{ height: 25 }}
        dataSource={this.state.siteData}
        fields={{
          text: 'organization_code',
          value: 'organization_id',
        }}
      />
    );
  }

  addResourceMaster(objCommer: any) {
    loadingShow(true, 'Adding');
    var theStartDate = new Date(objCommer.data.emp_start_date).getTime();
    var theEndDate = new Date(objCommer.data.emp_end_date).getTime();
    if (theEndDate < theStartDate) {
      Message.warning('End date cannot be past.');
      objCommer.cancel = true;
      loadingShow(false);
      return;
    }
    const obj = {
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      assignment_id: objCommer.data.assignment_id,
      department_id: this.DDRMDepartment.value,
      first_name: objCommer.data.first_name,
      last_name: objCommer.data.last_name,
      middle_name: objCommer.data.middle_name,
      alias_name: objCommer.data.alias_name,
      manager_id: this.DDRMManager.value,
      position_id: this.DDRMPosition.value,
      site_id: this.DDRMSite.value,
      emp_start_date: objCommer.data.emp_start_date,
      emp_end_date: objCommer.data.emp_end_date,
      email: objCommer.data.email,
      contact_number: objCommer.data.contact_number,
      is_tradesperson: this.switchForIsTradePerson.checked,
      is_mastered: true,
      job_title: '',
    };
    if (this.isAdd) {
      addAssignment(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getResourceMaster();
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      editAssignment(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getResourceMaster();
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(
              err.response.data +
                '\n' +
                err.response.status +
                '\n' +
                err.response.headers
            );
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  }
  componentDidMount() {
    this.getDepartment();
    this.getCompanySites();
    this.getPositions();
    this.getEventResources();
  }
  ConvertToDate(val: any) {
    var num = parseInt(val.substring(6, 19));
    var date = moment(num).format('MM/DD/yyyy');
    return new Date(date);
  }
  getResourceMaster() {
    getMasterAssignment()
      .then((el) => {
        (this.ResourceMasterGrid as GridComponent).dataSource = el.data;
      })
      .catch((e) => {
        //(e);
      });
  }
  actionBegin(args: any) {
    if (args.requestType === 'refresh') {
    }
    if (args.action === 'add') {
      this.isAdd = true;
      this.addResourceMaster(args);
    } else if (args.action === 'edit') {
      this.isAdd = false;
      this.addResourceMaster(args);
    } else if (args.requestType === 'delete') {
      this.assignment_id = args.data[0].assignment_id;
      this.deleteResourceMaster();
    }
  }

  private isCompleteTemplate(args: any) {
    let isComplete = args.is_tradesperson;
    return (
      <div>
        {isComplete ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  }
  private isCompletetemplateEditing(args: any) {
    return (
      <SwitchComponent
        checked={args.is_tradesperson}
        ref={(scope) => (this.switchForIsTradePerson = scope)}
      />
    );
  }
  onGridCreated = () => {
    if (this.props.gridRef) {
      this.props.gridRef(this.ResourceMasterGrid);
    }
    getMasterAssignment()
      .then((el) => {
        this.ResourceMasterGrid.dataSource = el.data;
      })
      .catch((e) => {
        //(e);
      });
  };
  render() {
    return (
      <div>
        <GridComponent
          id='resource-master-grid-123'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          height={
            this.props.height ? this.props.height : 'calc(-270px + 100vh)'
          }
          ref={(theGrid: GridComponent) => (this.ResourceMasterGrid = theGrid)}
          filterSettings={this.FilterOptions}
          created={this.onGridCreated.bind(this)}
          rowSelected={this.props.onGridSelected?.bind(this)}
          rowDeselected={this.props.onGridDeSelected?.bind(this)}
          allowFiltering={true}
          actionBegin={this.actionBegin.bind(this)}
          allowExcelExport
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          gridLines='Both'
          selectionSettings={{
            type: this.props.allowMultiSelectection ? 'Multiple' : 'Single',
          }}
          dataBound={() => {
            var searchEle = this.ResourceMasterGrid.element.querySelector(
              '#' + this.ResourceMasterGrid.element.id + '_searchbar'
            );
            if (searchEle) {
              searchEle.ariaAutoComplete = 'off'; // turn autocomplete off
            }
          }}
        >
          <ColumnsDirective>
            {this.props.allowMultiSelectection ? (
              <ColumnDirective type='checkbox' />
            ) : null}
            <ColumnDirective
              field='first_name'
              headerText='First name'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='middle_name'
              headerText='Middle name'
              textAlign='Left'
            />
            <ColumnDirective
              field='last_name'
              headerText='Last Name'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='alias_name'
              headerText='Alias Name'
              textAlign='Left'
            />
            <ColumnDirective
              field='position_name'
              headerText='Position'
              textAlign='Left'
              // editType='dropdownedit'
              editTemplate={this.positionTemplate.bind(this)}
            />
            <ColumnDirective
              field='department_code'
              headerText='Department'
              textAlign='Left'
              // editType='dropdownedit'
              editTemplate={this.departmentTemplate.bind(this)}
            />
            <ColumnDirective
              field='manager'
              headerText='Manager'
              textAlign='Left'
              // editType='dropdownedit'
              editTemplate={this.managerTemplate.bind(this)}
            />
            <ColumnDirective
              field='site_assigned'
              headerText='Site Asigned'
              textAlign='Left'
              // editType='dropdownedit'
              editTemplate={this.siteTemplate.bind(this)}
              allowEditing={false}
            />
            <ColumnDirective
              field='emp_start_date'
              headerText='Start Date'
              textAlign='Left'
              editType='datepickeredit'
              format='dd/MM/yyyy'
              type='date'
            />
            <ColumnDirective
              field='emp_end_date'
              headerText='End Date'
              textAlign='Left'
              editType='datepickeredit'
              format='dd/MM/yyyy'
              type='date'
            />
            <ColumnDirective
              field='email'
              headerText='Email'
              textAlign='Left'
            />
            <ColumnDirective
              field='contact_number'
              headerText='Contact Number'
              textAlign='Left'
            />
            <ColumnDirective
              field='is_tradesperson'
              headerText='Tradeperson Flag'
              textAlign='Left'
              template={this.isCompleteTemplate.bind(this)}
              editTemplate={this.isCompletetemplateEditing.bind(this)}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              ColumnChooser,
              ExcelExport,
              Page,
              ColumnMenu,
              Resize,
              Group
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default ResourceMaster;
